module.exports = __webpack_public_path__ + "img/builder-13.7afbca9d.webp";